module.exports = __webpack_public_path__ + "static/media/icon-notification.7d6b70f7.svg";